import Vue from "vue";

const consentcookie = {
    namespaced: true,
    state: {
        cookieConsent: {}
    },
    mutations: {
        setCookieConsent(state, cookieConsent) {
            state.cookieConsent = cookieConsent; 
        }
    }
};

export default consentcookie;